import { useTranslation } from 'react-i18next';
import useConfigurationStore from '../store/configurationStore';

export default function ProjectInfoStep() {
    const { t } = useTranslation();
    const {
        contactName, contactEmail, organizationName, countryRegion,
        desiredQuantity, desiredDeliveryDate, projectReference,
        setProjectInfo, leadEmail, leadName, leadOrganization,
    } = useConfigurationStore();

    // Pre-fill from lead info if empty.
    const email = contactEmail || leadEmail;
    const name = contactName || leadName;
    const org = organizationName || leadOrganization;

    return (
        <div className="ast-project-info">
            <div className="ast-wizard__step-header">
                <h2>Projectinformatie</h2>
                <p className="ast-wizard__step-desc">
                    Vul de basisgegevens in voor uw aanvraag. Deze informatie wordt gebruikt voor de offerte.
                </p>
            </div>

            <div className="ast-project-info__grid">
                <div className="ast-project-info__field">
                    <label>Organisatie / Bedrijfsnaam</label>
                    <input
                        type="text"
                        value={org}
                        onChange={(e) => setProjectInfo('organizationName', e.target.value)}
                        placeholder="Naam van uw organisatie"
                    />
                </div>

                <div className="ast-project-info__field">
                    <label>Contactpersoon</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setProjectInfo('contactName', e.target.value)}
                        placeholder="Uw naam"
                    />
                </div>

                <div className="ast-project-info__field">
                    <label>E-mailadres *</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setProjectInfo('contactEmail', e.target.value)}
                        placeholder="uw@email.nl"
                        required
                    />
                </div>

                <div className="ast-project-info__field">
                    <label>Land / Regio</label>
                    <select
                        value={countryRegion}
                        onChange={(e) => setProjectInfo('countryRegion', e.target.value)}
                    >
                        <option value="">Selecteer...</option>
                        <option value="NL">Nederland</option>
                        <option value="BE">België</option>
                        <option value="DE">Duitsland</option>
                        <option value="CH">Zwitserland</option>
                        <option value="AT">Oostenrijk</option>
                        <option value="LU">Luxemburg</option>
                        <option value="FR">Frankrijk</option>
                        <option value="overig">Overig</option>
                    </select>
                </div>

                <div className="ast-project-info__field">
                    <label>Gewenst aantal voertuigen</label>
                    <input
                        type="number"
                        min="1"
                        value={desiredQuantity || ''}
                        onChange={(e) => setProjectInfo('desiredQuantity', parseInt(e.target.value) || 1)}
                        placeholder="1"
                    />
                </div>

                <div className="ast-project-info__field">
                    <label>Gewenste leverdatum</label>
                    <input
                        type="text"
                        value={desiredDeliveryDate}
                        onChange={(e) => setProjectInfo('desiredDeliveryDate', e.target.value)}
                        placeholder="bijv. Q3 2026 of september 2026"
                    />
                </div>

                <div className="ast-project-info__field ast-project-info__field--full">
                    <label>Projectreferentie</label>
                    <input
                        type="text"
                        value={projectReference}
                        onChange={(e) => setProjectInfo('projectReference', e.target.value)}
                        placeholder="Uw interne referentie of projectnummer"
                    />
                </div>
            </div>
        </div>
    );
}
